import React from 'react'

const Footer = () => {
  return (
    <div style={{position:'relative'}}>
      <div className="footer-padding">
        <div className="footer">
            <p>Copyright by Travel & Tours</p>
        </div>
      </div>
    </div>
  )
}

export default Footer
